import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { CustomInput, CustomCheckbox, CustomTextArea, CustomIntInput } from "../ButtonComponentsPanel/CustomInputsComponents";
import { useHistory } from 'react-router-dom';

import FarmsService from "../../services/farms.service";

export default function FarmCreateComponents() {
    const { t } = useTranslation();
    const history = useHistory();

    const farm = {
        "integratorId": 0,
        "integratorCode": "",
        "manufacturerCode": "",
        "name": "",
        "officialMark": "",
        "regaCode": "",
        "gpsCordinates": "",
        "address": "",
        "city": "",
        "postcode": "",
        "provinceId": 0,
        "countryId": "",
        "remarks": "",
        "isInactive": false,
        "region": "",
        "distributionZoneId": 0,
        "farmTypeId": 0,
        "efficiencyRatio": 0
    };

    const handleSubmit = (dataItem) => {

        FarmsService.insertarFarm({
            "integratorId": dataItem.integratorId,
            "integratorCode": dataItem.integratorCode,
            "manufacturerCode": dataItem.manufacturerCode,
            "name": dataItem.name,
            "officialMark": dataItem.officialMark,
            "regaCode": dataItem.regaCode,
            "gpsCordinates": dataItem.gpsCordinates,
            "address": dataItem.address,
            "city": dataItem.city,
            "postcode": dataItem.postcode,
            "provinceId": dataItem.provinceId,
            "countryId": dataItem.countryId,
            "remarks": dataItem.remarks,
            "isInactive": dataItem.isInactive,
            "region": dataItem.region,
            "distributionZoneId": dataItem.distributionZoneId,
            "farmTypeId": dataItem.farmTypeId,
            "efficiencyRatio": dataItem.efficiencyRatio
        }).then(response => {
            history.push("/Farms/" + response.data.contract.farmId + "/DetailsFarms"); 
        }).catch(error => {
            console.error("There was an error creating the farm!", error);
        });
    }

    return (
        <div>

            <Form
                onSubmit={handleSubmit}
                initialValues={farm}
                key={JSON.stringify(farm)}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset>

                            <div className="container-fluid">
                                <div className="card">
                                    <div className="card-header">
                                        <b className="card-title">{t("Global_Label_Text_General")}</b>
                                    </div>

                                    <div className="container p-3 p-md-4">
                                        <div className="row g-3 mb-3">
                                            <div className="col-md-4">
                                                <Field
                                                    label={t("Global_Label_Text_Name")}
                                                    name="name"
                                                    component={CustomInput}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <Field
                                                    label={t("REGA")}
                                                    name="regaCode"
                                                    component={CustomInput}
                                                />
                                            </div>
                                            <div className="col-md-4 d-flex align-items-end">
                                                <Field
                                                    label={t("Global_Label_Text_Inactive")}
                                                    name="isInactive"
                                                    component={CustomCheckbox}
                                                />
                                            </div>
                                        </div>

                                        <div className="row g-3 mb-3">
                                            <div className="col-md-4">
                                                <Field
                                                    label={t("Global_Label_Text_Integrator")}
                                                    name="integratorId"
                                                    component={CustomInput}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <Field
                                                    label={t("Global_Label_Text_Code_Integrator")}
                                                    name="integratorCode"
                                                    component={CustomInput}
                                                />
                                            </div>
                                            <div className="col-md-4">
                                                <Field
                                                    label={t("Global_Label_Text_Manufacturer_Code")}
                                                    name="manufacturerCode"
                                                    component={CustomInput}
                                                />
                                            </div>
                                        </div>

                                        <div className="row g-3">
                                            <div className="col-md-4">
                                                <Field
                                                    label={t("Global_Label_Text_Official_Brand")}
                                                    name="officialMark"
                                                    component={CustomInput}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="container-fluid mt-4">
                                <div className="card">
                                    <div className="card-header">
                                        <b className="card-title m-0">{t("Global_Label_Text_Location")}</b>
                                    </div>

                                    <div className="container p-3 p-md-4">
                                        <div className="row g-3 mb-3">
                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_Address")}
                                                    name={'address'}
                                                    component={CustomInput}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_City")}
                                                    name={'city'}
                                                    component={CustomInput}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_Postcode")}
                                                    name={'postcode'}
                                                    component={CustomInput}
                                                />
                                            </div>

                                            <div className="col-12 col-sm-6 col-md-3">
                                                <Field
                                                    label={t("Global_Label_Text_GPS_Coordinates")}
                                                    name={'gpsCordinates'}
                                                    component={CustomInput}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="container-fluid mt-4">
                                <div className="row g-4">
                                    <div className="col-12 col-md-6">
                                        <div className="card h-100">
                                            <div className="card-header">
                                                <b className="card-title m-0">{t("Global_Label_Text_Parameters")}</b>
                                            </div>

                                            <div className="container p-3 p-md-4">
                                                <div className="row justify-content-center">
                                                    <div className="col-12 text-center">
                                                        <Field
                                                            label={t("Global_Label_Text_Eficiency")}
                                                            name={'efficiencyRatio'}
                                                            component={CustomIntInput}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="card h-100">
                                            <div className="card-header">
                                                <b className="card-title m-0">{t("Global_Label_Text_Remarks")}</b>
                                            </div>

                                            <div className="container p-3 p-md-4">
                                                <div className="row justify-content-center">
                                                    <div className="col-12 text-center">
                                                        <Field
                                                            label={t("Global_Label_Text_Remarks")}
                                                            name={'remarks'}
                                                            component={CustomTextArea}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </fieldset>
                        <br />
                        <div className="float-end k-form-buttons mb-3">
                            <button
                                type={'submit'}
                                disabled={!formRenderProps.allowSubmit}
                                className="k-button"
                            >
                                <span className="k-icon k-i-save" /> &nbsp; {t("Global_Label_Text_Save")}
                            </button>
                        </div>
                    </FormElement>)}
            />
        </div>


    );
}